import {
  Box,
  Button,
  Container,
  Grid,
  Link,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

import DynamicBreadcrumbs from '@/components/nav/Breadcrumb';
import ResourcesRightSidebar from '@/components/nav/ResourcesRightSidebar';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';

const Form4562 = () => {
  return (
    <AppLayout
      meta={
        <Meta
          title="IRS Form 4562: Depreciation & Amortization | TaxZerone"
          description=" Learn how to complete IRS Form 4562 to claim depreciation and amortization deductions for business assets. Understand Section 179, bonus depreciation."
          keywords=""
          canonical="resources/business-tax/form-4562/"
          ogType="article"
          jsonLdPricing="179.99"
          jsonLdAggregateRatingValue="4.97"
          jsonLdAggregateRatingCount="1658"
        />
      }
    >
      <Container maxWidth="lg" sx={{ textAlign: 'center' }}>
        <Typography
          variant="h1"
          sx={{
            fontSize: { lg: 40, md: 36, sm: 32, xs: 24 },
            fontWeight: 600,
            mb: 5,
            mt: 5,
            textAlign: 'center',
          }}
        >
          <span className="highlight-container">
            <span className="highlight">Form 4562</span>
          </span>{' '}
          Guide to Depreciation Deductions
        </Typography>
        {/* <Typography
          variant="body1"
          sx={{
            fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            mt: 1,
            mb: 2,
          }}
        >
          E-File your IRS <span style={{ fontWeight: 600 }}> Form 1120-S</span>{' '}
          for the 2024 tax year by{' '}
          <span style={{ fontWeight: 600 }}>March 17, 2025,</span> to meet
          federal S
          <Hidden smDown>
            {' '}
            <br />
          </Hidden>{' '}
          corporation filing deadlines and avoid potential penalties.
        </Typography>
        <Box sx={{ textAlign: 'center', mb: 4 }}>
          <Button
            variant="contained"
            className="btn-primary medium"
            sx={{
              fontSize: {
                xs: '16px !important',
                sm: '18px !important',
                lg: '24px !important',
              },
              transition: 'all 0.3s ease 0s',
              '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
            }}
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=1120sduedates`}
          >
            E-file Now!
          </Button> */}
        {/* </Box> */}
      </Container>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          py: 5,
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        mt={0}
      >
        <Container maxWidth="lg" sx={{ mb: 0 }}>
          <DynamicBreadcrumbs />
          <Grid
            container
            spacing={0}
            rowSpacing={0}
            m={0}
            sx={{ flexDirection: 'row-reverse' }}
          >
            <Grid
              size={{ xs: 12, md: 3.5, sm: 4.5 }}
              sx={{ display: { xs: 'none', sm: 'block' } }}
            >
              <ResourcesRightSidebar />
            </Grid>
            <Grid size={{ xs: 12, md: 8.5, sm: 7.5 }}>
              <Paper
                variant="outlined"
                sx={{
                  border: '1px solid #ccc',
                  p: 3,
                  px: 3,
                  textAlign: 'left',
                  mb: 0,
                  minHeight: '100%',
                }}
              >
                <Box
                  itemScope
                  itemType="https://schema.org/Article"
                  sx={{
                    p: 3,
                    px: 3,
                    backgroundColor: '#f0f5f8',
                    mb: 4,
                    borderRadius: 3,
                    position: 'relative',

                    '&::before': {
                      content: '""',
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '200px',
                      height: '130px',
                      borderTop: '2px solid #01456c',
                      borderLeft: '2px solid #01456c',
                      borderTopLeftRadius: '12px',
                    },

                    '&::after': {
                      content: '""',
                      position: 'absolute',
                      bottom: 0,
                      right: 0,
                      width: '200px',
                      height: '130px',
                      borderBottom: '2px solid #01456c',
                      borderRight: '2px solid #01456c',
                      borderBottomRightRadius: '12px',
                    },
                  }}
                >
                  <link
                    itemProp="mainEntityOfPage"
                    href="https://www.taxzerone.com/resources/business-tax/form-4562/"
                  />

                  {/* Article requires an image */}
                  <div
                    itemProp="image"
                    itemScope
                    itemType="https://schema.org/ImageObject"
                    style={{ display: 'none' }}
                  >
                    <link
                      itemProp="url"
                      href="https://www.taxzerone.com/assets/images/logo.webp"
                    />
                    <data itemProp="width" value="380" />
                    <data itemProp="height" value="124" />
                  </div>
                  <Box
                    sx={{
                      display: 'grid',
                      justifyContent: 'flex-start',
                      alignItems: 'center',
                      textAlign: 'left',
                      mb: 2,
                    }}
                  >
                    <Typography variant="body2">
                      Last updated:{' '}
                      <time
                        itemProp="datePublished"
                        dateTime="2026-08-25T09:00:00-05:00"
                      >
                        Aug 25, 2026
                      </time>
                      <time
                        itemProp="dateModified"
                        dateTime="2026-08-25T09:00:00-05:00"
                        style={{ display: 'none' }}
                      >
                        Aug 25, 2026
                      </time>
                    </Typography>

                    <Typography
                      variant="body2"
                      sx={{ fontWeight: 600 }}
                      itemProp="author"
                      itemScope
                      itemType="https://schema.org/Person"
                    >
                      -by{' '}
                      <span itemProp="name">
                        <a
                          itemProp="url"
                          href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}`}
                          style={{
                            color: 'inherit',
                            textDecoration: 'none',
                          }}
                        >
                          Nikhil Chowdary
                        </a>
                      </span>{' '}
                      | TaxZerone
                    </Typography>
                  </Box>
                  <Typography
                    variant="h4"
                    itemProp="headline"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { md: 20, sm: 18, xs: 16 },
                      color: '#01456c',
                      fontStyle: 'italic',
                    }}
                  >
                    Form 4562 at a Glance
                  </Typography>

                  <Typography variant="body1" sx={{ mb: 2 }}>
                    It is used by businesses to report{' '}
                    <span style={{ fontWeight: 600 }}>
                      depreciation and amortization deductions
                    </span>
                    , including Section 179 expenses, bonus depreciation, and
                    depreciation for business assets.
                  </Typography>

                  <Box
                    component="ul"
                    sx={{
                      mb: 0,
                      pl: 0,
                      listStyle: 'none',
                      '& li': { mb: 1.6, position: 'relative', pl: 3 },
                      '& li::before': {
                        content: '"★"',
                        position: 'absolute',
                        left: 0,
                        top: '-2px',
                        color: '#01456c',
                        fontSize: '18px',
                      },
                    }}
                  >
                    <li>
                      <span style={{ fontWeight: 600 }}>Who Files:</span>{' '}
                      Businesses that place property in service, claim{' '}
                      <span style={{ fontWeight: 600 }}>
                        Section 179 or bonus depreciation
                      </span>
                      , or report depreciation or amortization.
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>Filing:</span> File Form
                      4562 with your{' '}
                      <span style={{ fontWeight: 600 }}>
                        main business tax return
                      </span>
                      , such as Form 1120-S, Form 1065, Form 1120, or Schedule
                      C.
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>Key Deductions:</span>{' '}
                      Claim{' '}
                      <span style={{ fontWeight: 600 }}>
                        Section 179, bonus depreciation, MACRS depreciation, and
                        amortization
                      </span>{' '}
                      for qualifying business property and intangible assets.
                    </li>
                  </Box>
                </Box>
                <Stack
                  direction={{ xs: 'column-reverse', md: 'row' }}
                  spacing={{ xs: 1, sm: 2, md: 3 }}
                  sx={{ mb: 0 }}
                >
                  <Box>
                    <Typography variant="body1" sx={{ mb: 1 }}>
                      Every business that invests in equipment, vehicles,
                      buildings, or intangible property can recover the cost of
                      those assets over time through{' '}
                      <span style={{ fontWeight: 600 }}> depreciation</span> and
                      <span style={{ fontWeight: 600 }}> amortization</span>. To
                      claim these deductions, the IRS requires you to file{' '}
                      <Link
                        href="https://www.irs.gov/forms-pubs/about-form-4562"
                        target="_blank"
                        sx={{ color: '#0202ff' }}
                      >
                        {' '}
                        Form 4562
                      </Link>
                      ,{' '}
                      <span style={{ fontStyle: 'italic' }}>
                        {' '}
                        Depreciation and Amortization (Including Information on
                        Listed Property)
                      </span>
                      , along with your main business tax return.
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1 }}>
                      Form 4562 allows you to:
                    </Typography>
                    <Box component="ul" sx={{ '& li': { mb: 1.5 }, mb: 2 }}>
                      <li>
                        Deduct the cost of tangible business assets (machinery,
                        computers, office furniture, etc.)
                      </li>
                      <li>Claim Section 179 immediate expensing </li>
                      <li>
                        Report amortization for intangible property (goodwill,
                        trademarks, patents){' '}
                      </li>
                      <li>
                        Record depreciation for property placed in service in
                        the current or prior years{' '}
                      </li>
                    </Box>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                      Proper completion ensures you claim the right deduction
                      amounts, maintain compliance with IRS rules, and avoid
                      penalties or mismatched figures on your return.
                    </Typography>
                  </Box>
                  <Box
                    sx={{ mb: 1, textAlign: { xs: 'center', md: 'left' } }}
                  />
                </Stack>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 20, sm: 18, xs: 16 },
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 2,
                  }}
                >
                  What’s New for Form 4562 (Tax Year 2025)
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  The IRS has introduced several important updates to{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    Form 4562 (Depreciation and Amortization)
                  </span>{' '}
                  for tax years beginning in 2025 to improve cost-basis
                  tracking, aircraft reporting, and Section 179 limits.
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { md: 20, sm: 18, xs: 16 },
                    fontWeight: 600,
                    mb: 0.5,
                  }}
                >
                  1. Line 23 Split Into 23a and 23b
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Line 23 has been divided into{' '}
                  <span style={{ fontWeight: 600 }}>two separate lines</span> to
                  improve reporting of capitalized costs under{' '}
                  <span style={{ fontWeight: 600 }}>
                    Section 263A (Uniform Capitalization Rules)
                  </span>
                  :
                </Typography>
                <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.2 } }}>
                  <li>
                    <span style={{ fontWeight: 600 }}>Line 23a —</span> Basis
                    attributable to{' '}
                    <span style={{ fontWeight: 600 }}>interest costs</span>{' '}
                    capitalized under{' '}
                    <span style={{ fontWeight: 600 }}>Section 263A(f)</span>
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}>Line 23b —</span> Basis
                    attributable to{' '}
                    <span style={{ fontWeight: 600 }}>
                      other capitalized costs
                    </span>
                    under{' '}
                    <span style={{ fontWeight: 600 }}>Section 263A</span>{' '}
                  </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  This change helps the IRS distinguish financing costs from
                  production or acquisition costs when calculating depreciation.
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { md: 20, sm: 18, xs: 16 },
                    fontWeight: 600,
                    mb: 0.5,
                  }}
                >
                  2. New Line 24c for Aircraft Reporting
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  A new <span style={{ fontWeight: 600 }}>Line 24c</span> has
                  been added to{' '}
                  <span style={{ fontWeight: 600 }}>
                    Part V (Listed Property)
                  </span>
                  .
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  If your business{' '}
                  <span style={{ fontWeight: 600 }}>
                    owns, leases, or charters an aircraft
                  </span>{' '}
                  and claims depreciation on it, you must now check all boxes
                  that apply to disclose:
                </Typography>
                <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.2 } }}>
                  <li>Ownership </li>
                  <li>Leasing </li>
                  <li>Charter use </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  This improves IRS oversight of aircraft depreciation and
                  business-use compliance
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { md: 20, sm: 18, xs: 16 },
                    fontWeight: 600,
                    mb: 0.5,
                  }}
                >
                  3. Section 179 Limits Increased for 2025
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  For tax years beginning in{' '}
                  <span style={{ fontWeight: 600 }}>2025,</span> the IRS has
                  increased Section 179 limits:
                </Typography>
                <Box component="div" sx={{ mb: 2 }}>
                  <TableContainer sx={{ border: '1px solid #828282' }}>
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow
                          sx={{ backgroundColor: '#ccc', fontWeight: 600 }}
                        >
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Category
                          </TableCell>

                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            2025 Limit
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow sx={{}}>
                          <TableCell sx={{ fontWeight: 600 }}>
                            Maximum Section 179 deduction
                          </TableCell>
                          <TableCell sx={{ fontWeight: 600 }}>
                            $2,500,000{' '}
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell sx={{ fontWeight: 600 }}>
                            Phase-out threshold
                          </TableCell>
                          <TableCell sx={{ fontWeight: 600 }}>
                            $4,000,000
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell sx={{ fontWeight: 600 }}>
                            SUV Section 179 cap
                          </TableCell>
                          <TableCell sx={{ fontWeight: 600 }}>
                            $31, 300{' '}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  If your business places more than{' '}
                  <span style={{ fontWeight: 600 }}> $4,000,000</span> of
                  Section 179 property in service, the deduction begins to phase
                  out dollar-for-dollar.
                </Typography>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 20, sm: 18, xs: 16 },
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 2,
                  }}
                >
                  What Is IRS Form 4562?
                </Typography>

                <Typography variant="body1" sx={{ mb: 2 }}>
                  <span style={{ fontWeight: 600 }}>IRS Form 4562</span> is used
                  by businesses to report{' '}
                  <span style={{ fontWeight: 600 }}>
                    depreciation and amortization deductions.
                  </span>{' '}
                  It serves as the IRS’s verification document for property cost
                  recovery and helps ensure assets are depreciated properly
                  under the{' '}
                  <span style={{ fontWeight: 600 }}>
                    Modified Accelerated Cost Recovery System (MACRS)
                  </span>{' '}
                  or the{' '}
                  <span style={{ fontWeight: 600 }}>
                    Alternative Depreciation System (ADS)
                  </span>
                  .
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  Depreciation vs. Amortization
                </Typography>
                <Box component="div" sx={{ mb: 4 }}>
                  <TableContainer sx={{ border: '1px solid #828282' }}>
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow
                          sx={{ backgroundColor: '#ccc', fontWeight: 600 }}
                        >
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Term
                          </TableCell>

                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Applies To
                          </TableCell>
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Recovery Type
                          </TableCell>
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Example
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow sx={{}}>
                          <TableCell sx={{ fontWeight: 600 }}>
                            Depreciation{' '}
                          </TableCell>
                          <TableCell>Tangible assets</TableCell>
                          <TableCell>Cost recovery over asset life</TableCell>
                          <TableCell>Equipment, Vehicles, Buildings</TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell sx={{ fontWeight: 600 }}>
                            Amortization{' '}
                          </TableCell>
                          <TableCell>Intangible assets</TableCell>
                          <TableCell>
                            Even allocation over asset’s useful life
                          </TableCell>
                          <TableCell>
                            Patents, Copyrights, Startup Costs
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.5,
                  }}
                >
                  Why Form 4562 Matters
                </Typography>

                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  1. Accurate Cost Recovery
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Businesses invest in long-term assets that lose value with
                  time. Depreciation ensures your financial statements and tax
                  returns reflect this reduction accurately.
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  2. Tax Savings
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  By spreading deductions across multiple years or electing
                  Section 179, you reduce your{' '}
                  <span style={{ fontWeight: 600 }}> taxable income</span>,
                  freeing up cash for reinvestment.
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  3. IRS Compliance
                </Typography>
                <Typography variant="body1" sx={{ mb: 4 }}>
                  Form 4562 ensures depreciation follows IRS recovery periods,
                  methods, and property classification rules. Misreporting can
                  result in penalties or rejected returns.
                </Typography>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 2,
                  }}
                >
                  Who Must File Form 4562?
                </Typography>

                <Typography variant="body1" sx={{ mb: 1 }}>
                  You must file{' '}
                  <span style={{ fontWeight: 600 }}>Form 4562</span> if, during
                  the year, your business:
                </Typography>
                <Box component="ul" sx={{ mb: 3, '& li': { mb: 1.2 } }}>
                  <li>
                    Placed property in service for depreciation or amortization
                  </li>
                  <li>
                    {' '}
                    Is claiming a{' '}
                    <span style={{ fontWeight: 600 }}>
                      Section 179 deduction{' '}
                    </span>
                  </li>
                  <li>
                    {' '}
                    Is claiming a{' '}
                    <span style={{ fontWeight: 600 }}>
                      special (bonus) depreciation allowance
                    </span>{' '}
                  </li>
                  <li>
                    Has listed property used for both personal and business
                    purposes{' '}
                  </li>
                  <li>
                    Is reporting depreciation from{' '}
                    <span style={{ fontWeight: 600 }}>rental real estate</span>{' '}
                    on{' '}
                    <Link
                      href="https://www.irs.gov/forms-pubs/about-form-8825"
                      target="_blank"
                      sx={{ color: '#0202ff' }}
                    >
                      {' '}
                      Form 8825
                    </Link>{' '}
                  </li>
                  <li>Continues depreciation from prior-year placed assets </li>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  Entities Required to File
                </Typography>
                <Box component="div" sx={{ mb: 4 }}>
                  <TableContainer sx={{ border: '1px solid #828282' }}>
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow
                          sx={{ backgroundColor: '#ccc', fontWeight: 600 }}
                        >
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Entity Type
                          </TableCell>

                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Return Form
                          </TableCell>
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            4562 Attachment Required
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow sx={{}}>
                          <TableCell sx={{ fontWeight: 600 }}>
                            S Corporation{' '}
                          </TableCell>
                          <TableCell>
                            <Link
                              href="/business-tax/efile-irs-form-1120-s/"
                              sx={{ color: '#0202ff' }}
                            >
                              {' '}
                              Form 1120-S
                            </Link>{' '}
                          </TableCell>
                          <TableCell>Yes, attach to return</TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell sx={{ fontWeight: 600 }}>
                            C Corporation{' '}
                          </TableCell>
                          <TableCell>
                            <Link
                              href="https://www.irs.gov/forms-pubs/about-form-1120"
                              target="_blank"
                              sx={{ color: '#0202ff' }}
                            >
                              {' '}
                              Form 1120
                            </Link>{' '}
                          </TableCell>
                          <TableCell>
                            Yes, if claiming depreciation or amortization{' '}
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell sx={{ fontWeight: 600 }}>
                            Partnership{' '}
                          </TableCell>
                          <TableCell>
                            <Link
                              href="https://www.irs.gov/forms-pubs/about-form-1065"
                              target="_blank"
                              sx={{ color: '#0202ff' }}
                            >
                              {' '}
                              Form 1065
                            </Link>{' '}
                          </TableCell>
                          <TableCell>Yes</TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell sx={{ fontWeight: 600 }}>
                            Sole Proprietor{' '}
                          </TableCell>
                          <TableCell>
                            <Link
                              href="https://www.irs.gov/forms-pubs/about-schedule-c-form-1040"
                              target="_blank"
                              sx={{ color: '#0202ff' }}
                            >
                              {' '}
                              Schedule C (Form 1040)
                            </Link>{' '}
                          </TableCell>
                          <TableCell>
                            Yes, if business property is depreciated
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell sx={{ fontWeight: 600 }}>
                            Rental Real Estate Entity{' '}
                          </TableCell>
                          <TableCell>
                            <Link
                              href="/resources/business-tax/form-8825/"
                              sx={{ color: '#0202ff' }}
                            >
                              {' '}
                              Form 8825
                            </Link>{' '}
                          </TableCell>
                          <TableCell>Yes, for building depreciation </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 2,
                  }}
                >
                  Form 4562 Filing Deadlines
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Form 4562 is due on the same date as your main tax return:
                </Typography>
                <Box component="div" sx={{ mb: 4 }}>
                  <TableContainer sx={{ border: '1px solid #828282' }}>
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow
                          sx={{ backgroundColor: '#ccc', fontWeight: 600 }}
                        >
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Entity
                          </TableCell>

                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Main Return
                          </TableCell>
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Filing Deadline
                          </TableCell>
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Extension Form
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow sx={{}}>
                          <TableCell>S Corporation </TableCell>
                          <TableCell>Form 1120-S</TableCell>
                          <TableCell>March 16, 2026</TableCell>
                          <TableCell>Form 7004</TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>Partnership </TableCell>
                          <TableCell>Form 1065</TableCell>
                          <TableCell>March 16, 2026</TableCell>
                          <TableCell>Form 7004 </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell>C Corporation </TableCell>
                          <TableCell>Form 1120 </TableCell>
                          <TableCell>April 15, 2026 </TableCell>
                          <TableCell>Form 7004</TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>Sole Proprietorship </TableCell>
                          <TableCell>Schedule C with Form 1040 </TableCell>
                          <TableCell>April 15, 2026 </TableCell>
                          <TableCell>Form 4868 </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 2,
                  }}
                >
                  Step-by-Step Breakdown of IRS Form 4562
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Form 4562 is divided into{' '}
                  <span style={{ fontWeight: 600 }}> six parts</span>, each
                  focusing on a specific deduction type or asset classification.
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  Part I: Election to Expense Certain Property (Section 179)
                </Typography>
                <Typography variant="body1" sx={{ mb: 1, fontWeight: 600 }}>
                  Purpose:
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Allows businesses to{' '}
                  <span style={{ fontWeight: 600 }}> immediately deduct</span>{' '}
                  the cost of qualifying property instead of depreciating it
                  over time.
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>
                    <span style={{ fontWeight: 600 }}> Line 1:</span> Enter the
                    total cost of Section 179 property placed in service.{' '}
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}> Line 2:</span> Enter the
                    maximum Section 179 dollar limitation{' '}
                    <span style={{ fontWeight: 600 }}>
                      ($2,500,000 for tax years beginning in 2025)
                    </span>
                    .
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}> Line 5:</span> Deduct
                    property cost up to the annual limit.
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}> Line 11:</span> The
                    Section 179 phase-out begins when total qualifying property
                    placed in service exceeds{' '}
                    <span style={{ fontWeight: 600 }}>$4,000,000.</span>
                  </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 1, fontWeight: 600 }}>
                  Qualifying Property:
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>
                    Equipment, computers, furniture, machinery, vehicles used
                    &gt; 50% for business
                  </li>
                  <li>Off-the-shelf software</li>
                  <li>Certain qualified improvement property (QIP)</li>
                </Box>
                <Typography variant="body1" sx={{ mb: 1, fontWeight: 600 }}>
                  Non-Qualifying Property:
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>Land or buildings</li>
                  <li>Assets used for lodging </li>
                  <li>Property used less than 50% for business</li>
                </Box>
                <Typography variant="body1" sx={{ mb: 1, fontWeight: 600 }}>
                  Example:
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  XYZ Corp buys machinery worth $150,000.
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  They can claim the full $150,000 deduction under Section 179
                  if they meet IRS criteria.
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  Part II: Special Depreciation Allowance (Bonus Depreciation)
                </Typography>
                <Typography variant="body1" sx={{ mb: 1, fontWeight: 600 }}>
                  Purpose:
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Allows an additional deduction (80% in 2026) on qualified new
                  or used property placed in service during the year.
                </Typography>
                <Typography variant="body1" sx={{ mb: 1, fontWeight: 600 }}>
                  Eligible Property:
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>Tangible property with a recovery period ≤ 20 years </li>
                  <li>Qualified improvement property </li>
                  <li>Computer software and certain listed assets </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Example:
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  If you buy $100,000 worth of qualified property, you can claim
                  <span style={{ fontWeight: 600 }}> $80,000</span> as bonus
                  depreciation in 2026, and depreciate the remaining $20,000
                  over the asset’s life.
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  Part III: MACRS Depreciation (Regular Depreciation)
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Purpose:
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  For assets that are depreciated annually over their useful
                  lives using <span style={{ fontWeight: 600 }}> MACRS</span> —
                  the IRS’s default system.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Depreciation Methods:
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>
                    <span style={{ fontWeight: 600 }}>
                      200% Declining Balance (DB):
                    </span>{' '}
                    Accelerated method (e.g., machinery, computers){' '}
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}>150% DB:</span> Used for
                    certain types of property or if elected{' '}
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}>Straight-Line (SL):</span>{' '}
                    Equal annual depreciation over asset life{' '}
                  </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Typical Recovery Periods:
                </Typography>

                <Box component="div" sx={{ mb: 2 }}>
                  <TableContainer sx={{ border: '1px solid #828282' }}>
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow
                          sx={{ backgroundColor: '#ccc', fontWeight: 600 }}
                        >
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Property Type
                          </TableCell>

                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Recovery Period
                          </TableCell>
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Method
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow sx={{}}>
                          <TableCell>Computers & Equipment </TableCell>
                          <TableCell>5 years</TableCell>
                          <TableCell>200% DB</TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>Office Furniture </TableCell>
                          <TableCell>7 years</TableCell>
                          <TableCell>200% DB</TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell>Residential Rental Property </TableCell>
                          <TableCell>27.5 years</TableCell>
                          <TableCell>SL</TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>Non-Residential Building </TableCell>
                          <TableCell>39 years</TableCell>
                          <TableCell>SL</TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Example:
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  If your business buys office furniture for $14,000, you’ll
                  depreciate it over 7 years using 200% DB method, unless you
                  elect otherwise.
                </Typography>

                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  Part IV: Summary
                </Typography>

                <Typography variant="body1" sx={{ mb: 1 }}>
                  This section consolidates all deductions claimed:
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  New for 2025 — Capitalized Cost Reporting (Section 263A):
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Line 23 of Form 4562 has been split into{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    Line 23a and Line 23b.
                  </span>
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  <span style={{ fontWeight: 600 }}>Line 23a </span> reports the
                  portion of asset basis attributable to{' '}
                  <span style={{ fontWeight: 600 }}>
                    interest costs capitalized under Section 263A(f).
                  </span>
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  <span style={{ fontWeight: 600 }}>Line 23b </span> reports the
                  portion of basis attributable to{' '}
                  <span style={{ fontWeight: 600 }}>
                    all other costs capitalized under Section 263A.
                  </span>
                </Typography>
                <Typography variant="body1">
                  This separation ensures that financing costs and production or
                  acquisition costs are depreciated correctly.
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>
                    Add up Section 179, bonus depreciation, and MACRS
                    amounts.{' '}
                  </li>
                  <li>
                    The total deduction is transferred to your main tax
                    return:{' '}
                  </li>
                  <ul>
                    <li>Form 1120-S: Line 14 </li>
                    <li>Form 1065: Line 16a </li>
                    <li>Schedule C: Line 13 </li>
                  </ul>
                </Box>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Ensure these totals{' '}
                  <span style={{ fontWeight: 600 }}>match exactly</span> to
                  avoid IRS mismatch notices.
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  Part V: Listed Property
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  New for TY 2025 — Aircraft Reporting:
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  A new <span style={{ fontWeight: 600 }}>Line 24c</span> has
                  been added. If your business{' '}
                  <span style={{ fontWeight: 600 }}>
                    owns, leases, or charters an aircraft
                  </span>{' '}
                  for which depreciation is claimed, you must now check the
                  applicable boxes to disclose how the aircraft is used. This
                  improves IRS oversight of aircraft depreciation and
                  business-use compliance.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5 }}>
                  Used for assets with{' '}
                  <span style={{ fontWeight: 600 }}> dual use</span> (business
                  and personal).
                </Typography>

                <Typography variant="body1" sx={{ mb: 1 }}>
                  Examples include vehicles, cameras, or computers.
                </Typography>
                <Box component="ul" sx={{ mb: 3, '& li': { mb: 1.2 } }}>
                  <li>
                    Must maintain{' '}
                    <span style={{ fontWeight: 600 }}>business usage logs</span>{' '}
                    (e.g., mileage records).
                  </li>
                  <li>
                    Business use must be{' '}
                    <span style={{ fontWeight: 600 }}> &gt; 50%</span> to
                    qualify for Section 179.
                  </li>
                  <li>Report percentage of business vs. personal use. </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Example:
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  If your vehicle is used 70% for business, you can depreciate
                  only 70% of its cost.
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  Part VI: Amortization
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  This section reports deductions for intangible property.{' '}
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Common Intangibles:
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>Goodwill </li>
                  <li>Trademarks and patents </li>
                  <li>Startup and organizational costs </li>
                  <li>Franchises or licenses</li>
                </Box>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  <span style={{ fontWeight: 600 }}> Amortization Period:</span>{' '}
                  Typically 15 years (straight-line method).
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Example:
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  If you incur $45,000 in organizational costs, you can amortize
                  them equally over 15 years ($3,000 per year).
                </Typography>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.5,
                  }}
                >
                  Special Situations & Reporting
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  1. Depreciation for Rental Real Estate
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  If your entity owns rental property, report income and
                  expenses on Form 8825 , and use{' '}
                  <Link
                    href="https://www.irs.gov/pub/irs-pdf/f4562.pdf"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    Form 4562
                  </Link>{' '}
                  to record depreciation.
                </Typography>
                <Typography variant="body1" sx={{ mb: 3, fontStyle: 'italic' }}>
                  File rental income and depreciation accurately using{' '}
                  <Link
                    href="/resources/business-tax/form-8825/"
                    sx={{ color: '#0202ff' }}
                  >
                    Form 8825
                  </Link>
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  2. Passive Activity Limitations
                </Typography>

                <Typography variant="body1" sx={{ mb: 3 }}>
                  Depreciation deductions may be limited under{' '}
                  <span style={{ fontWeight: 600 }}> IRC Section 469</span> if
                  the activity is passive. Losses are only deductible against
                  passive income unless you qualify as a real estate
                  professional.
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  3. Vehicle Depreciation Limits
                </Typography>

                <Typography variant="body1" sx={{ mb: 3 }}>
                  For vehicles placed in service in{' '}
                  <span style={{ fontWeight: 600 }}> 2025</span>, the{' '}
                  <span style={{ fontWeight: 600 }}>
                    Section 179 SUV deduction cap is $31,300,
                  </span>{' '}
                  and <br /> luxury-auto depreciation limits still apply based
                  on IRS annual tables. Business-use records are mandatory.
                </Typography>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.5,
                  }}
                >
                  Common Mistakes to Avoid
                </Typography>
                <Box component="div" sx={{ mb: 4 }}>
                  <TableContainer sx={{ border: '1px solid #828282' }}>
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow
                          sx={{ backgroundColor: '#ccc', fontWeight: 600 }}
                        >
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Error
                          </TableCell>

                          <TableCell
                            sx={{ color: '#444', width: 100, fontWeight: 600 }}
                          >
                            Impact
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow sx={{}}>
                          <TableCell>
                            Claiming Section 179 on ineligible property{' '}
                          </TableCell>
                          <TableCell>Deduction disallowed </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>
                            Not reducing depreciable basis by Section 179
                            claimed{' '}
                          </TableCell>
                          <TableCell>Overstated deductions </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell>
                            Ignoring listed property usage documentation{' '}
                          </TableCell>
                          <TableCell>Partial or denied deduction </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>
                            Mismatch between{' '}
                            <Link
                              href="https://www.irs.gov/pub/irs-pdf/f4562.pdf"
                              target="_blank"
                              sx={{ color: '#0202ff' }}
                            >
                              {' '}
                              Form 4562
                            </Link>{' '}
                            and{' '}
                            <Link
                              href="/business-returns/efile-irs-form-1120-s/"
                              sx={{ color: '#0202ff' }}
                            >
                              Form 1120-S
                            </Link>{' '}
                            totals{' '}
                          </TableCell>
                          <TableCell>IRS notice or adjustment </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell>
                            Omitting prior-year assets still being depreciated
                          </TableCell>
                          <TableCell>Underreporting </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 2,
                  }}
                >
                  Best Practices for Compliance
                </Typography>

                <Box component="ul" sx={{ '& li': { mb: 1.5 }, mb: 4 }}>
                  <li>
                    Keep invoices, purchase dates, and usage records for all
                    assets.
                  </li>
                  <li>
                    Review IRS{' '}
                    <span style={{ fontWeight: 600 }}> Publication 946</span>{' '}
                    for annual updates on depreciation limits.
                  </li>
                  <li>Apply the same method for similar property classes.</li>
                  <li>
                    Reconcile totals with your main return (Form 1120-S or
                    1065).{' '}
                  </li>
                  <li>
                    Use{' '}
                    <span style={{ fontWeight: 600 }}>
                      TaxZerone’s guided e-filing
                    </span>{' '}
                    to auto-attach Form 4562 when applicable.
                  </li>
                </Box>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 20, sm: 18, xs: 16 },
                    fontWeight: 600,
                    mb: 2,
                  }}
                >
                  Frequently Asked Questions (FAQs)
                </Typography>

                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  1. Do all businesses file Form 4562?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  No. Only those claiming depreciation or amortization
                  deductions must file.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  2. Can I e-file Form 4562 separately?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  No. It must be submitted with your business return (e.g., Form
                  1120-S, 1065, or Schedule C).
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  3. What’s the difference between Section 179 and Bonus
                  Depreciation?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Section 179 lets you{' '}
                  <span style={{ fontWeight: 600 }}>electively deduct</span>{' '}
                  asset costs up to an annual limit, while bonus depreciation is{' '}
                  <span style={{ fontWeight: 600 }}>automatic</span> and applies
                  after Section 179.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  4. Do rental property owners use Form 4562?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Yes, if they are depreciating buildings, improvements, or
                  furnishings used for rental. See{' '}
                  <span style={{ fontWeight: 600 }}>Form 8825</span> for
                  details.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  5. How long should I keep depreciation records?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Keep all asset-related records for at least{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    7 years after the asset’s disposal.
                  </span>
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Container maxWidth="lg" sx={{ mb: 5, my: { xs: 6, sm: 6, md: 6 } }}>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={{ xs: 2, md: 5 }}
        >
          <Box
            sx={{
              width: '100%',
              textAlign: 'center',
            }}
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 2,
                textAlign: 'center',
                lineHeight: 1.5,
              }}
            >
              E-File Your Form 1120-S with TaxZerone
            </Typography>
            <Typography
              variant="h3"
              sx={{
                fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                fontWeight: 400,
                color: '#333333',
                mb: 3,
              }}
            >
              Easily include Form 4562 for depreciation and amortization while
              ensuring IRS accuracy and compliance.
            </Typography>

            <Box sx={{ textAlign: { xs: 'center', md: 'center' } }}>
              <Button
                variant="contained"
                sx={{
                  mt: 1,
                  transition: 'all 0.3s ease 0s',
                  '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                }}
                className="btn-primary"
                href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=4562`}
              >
                Start Filing Now
              </Button>
            </Box>
          </Box>
        </Stack>
      </Container>
    </AppLayout>
  );
};

export default Form4562;
